import {actionTypes} from '@servicenow/ui-internal';

export const DISPATCH_EVENT = 'DISPATCH_CUSTOM_EVENT';
export const COMPONENT_ID_ATTRIBUTE = 'component-id';
export const ATTRIBUTE_SET = 'ATTRIBUTE_SET';
export const STORE_UPDATED = 'STORE_UPDATED';
export const HANDLE_ACTIONS = 'handle-actions';
export const PROPERTIES_SET = 'PROPERTIES_SET';
export const SHOULD_NOT_PROPAGATE = [PROPERTIES_SET, STORE_UPDATED];
export const PARSE_PROP_CONF_KEY = 'unstableParse';
export const SET_INITIAL_STATE = 'SET_INITIAL_STATE';
export const COMPONENT_NAME_ATTR = 'component-name';
export const COMPONENT_NAME_PROP = 'componentName';
export const HOIST_APPEND_TO_PROP = 'hoistAppendTo';
export const HOIST_APPEND_TO_ATTR = 'hoist-append-to';
export const HOIST_ATTR = 'hoist';
export const SEISMIC_HOIST_TAG_NAME = 'SEISMIC-HOIST';
export const HOIST_FIRST_SCROLL_PARENT = 'now-unstable-first-scroll-parent';
export const DEFER_ATTRIBUTE = 'defer';
export const APPEND_TO_PAYLOAD_PROP_NAME = 'appendToPayload';
export const APPEND_TO_META_PROP_NAME = 'appendToMeta';
export const PROPERTY_SELECTOR_SIGIL = '@';
export const PROPERTIES_SET_LIFECYCLE = 'onPropertiesSet';

// legacy life cycle functions
export const ON_CONNECT_LIFECYCLE = 'onConnect';
export const ON_DISCONNECT_LIFECYCLE = 'onDisconnect';
export const ON_BOOTSTRAP_LIFECYCLE = 'onBootstrap';

// public action types
export const {COMPONENT_CONNECTED} = actionTypes;
export const {COMPONENT_DISCONNECTED} = actionTypes;
export const {COMPONENT_BOOTSTRAPPED} = actionTypes;
export const {COMPONENT_PROPERTY_CHANGED} = actionTypes;
export const {COMPONENT_RENDERED} = actionTypes;
export const {COMPONENT_DOM_READY} = actionTypes;
export const {COMPONENT_PROPERTY_UPDATE_REQUESTED} = actionTypes;
export const {COMPONENT_RENDER_REQUESTED} = actionTypes;
export const {COMPONENT_DOM_TREE_READY} = actionTypes;
export const {COMPONENT_TREE_RENDERED} = actionTypes;
export const {COMPONENT_ACTION_DISPATCHED} = actionTypes;
export const {COMPONENT_INTERACTIVE} = actionTypes;

// now namespace
export const NOW_HOIST_ATTR = 'now-hoist';
export const NOW_HOIST_PROP = 'nowHoist';
export const NOW_HOIST_APPEND_TO_ATTR = 'now-hoist-append-to';
export const NOW_HOIST_PREPEND_TO_ATTR = 'now-hoist-prepend-to';
export const NOW_HOIST_APPEND_TO_PROP = 'nowHoistAppendTo';
export const NOW_HOIST_PREPEND_TO_PROP = 'nowHoistPrependTo';
export const NOW_ID_ATTR = 'now-id';
export const NOW_ID_PROP = 'nowId';
export const NOW_COMPONENT_NAME_ATTR = 'now-name';
export const NOW_COMPONENT_NAME_PROP = 'nowName';
export const NOW_ENABLE_PROPERTY_SETTING_PREVENTION_ATTR = 'now-enable-property-setting-prevention';
export const NOW_ENABLE_PROPERTY_SETTING_PREVENTION_PROP = 'nowEnablePropertySettingPrevention';
export const NOW_LOGGING_LEVELS_PROP = 'nowLoggingLevels';
export const NOW_PLACEHOLDER_HEIGHT_PROP = 'nowPlaceholderHeight';
export const NOW_PLACEHOLDER_WIDTH_PROP = 'nowPlaceholderWidth';

// priorities
export const NOW_PRIORITY_ATTR = 'now-priority';
export const NOW_PRIORITY_PROP = 'nowPriority';
export const PRIORITY_LEVEL_LOW = 'low';
export const PRIORITY_LEVEL_MEDIUM = 'medium';

// modes
export const NOW_MODE_ATTR = 'now-mode';
export const NOW_MODE_PROP = 'nowMode';
export const COMPONENT_MODE_ACTIVE = 'active';
export const COMPONENT_MODE_SUSPEND = 'suspend';
export const COMPONENT_MODE_DETACH = 'detach';

// metrics
export const NOW_METRIC_TYPES_PROP = 'nowMetricTypes';
export const NOW_METRICS_LEVEL_PROP = 'nowMetricsLevel';

export const NOW_UI_EVENT = 'NOW_UI_EVENT';
// now event types
export const STATE_UPDATED = 'STATE_UPDATED';
export const ACTION_DISPATCHED = 'ACTION_DISPATCHED';
export const ACTION_HANDLED = 'ACTION_HANDLED';

export const SCHEDULE_IMMEDIATELY_DO_NOT_USE_OR_YOU_WILL_BE_IMMEDIATELY_FIRED =
	'SCHEDULE_IMMEDIATELY_DO_NOT_USE_OR_YOU_WILL_BE_IMMEDIATELY_FIRED';
export const COMPONENT_INTERNAL_ACTION = 'NOW_COMPONENT_INTERNAL_ACTION';

export const HELPERS_IMMEDIATE = 'HELPERS_IMMEDIATE';
export const HELPERS_DEFER = 'HELPERS_DEFER';
export const HELPERS_SCHEDULED = 'HELPERS_SCHEDULED';
export const PACKAGE_NAME = '@servivcenow/ui-core';

export const SHADOW_ROOT_MODE_CLOSED = 'closed';
export const SHADOW_ROOT_MODE_OPEN = 'open';

export const COMPONENT_STATE_UPDATED = 'SEISMIC_COMPONENT_STATE_UPDATED';

// Avoid re-render prop used to avoid component re-render if new & old states are same
export const NOW_AVOID_RENDER_PROP = 'nowAvoidRender';

export const ARIA_LIVE_REGION_UPDATE_REQUESTED = 'SEISMIC_ARIA_LIVE_REGION_UPDATE_REQUESTED';
export const ARIA_LIVE_POLITE = 'polite';
export const ARIA_LIVE_ASSERTIVE = 'assertive';
